const { default: axiosIns } = require('@/libs/axios')

const TargetingService = {
  // GET - TargetingApiController
  async getTargetingProperties() {
    return axiosIns.get('admin/targeting').then(response => response.data)
  },
  // PUT - TargetingApiController
  async updateTargetingProperties(targeting) {
    return axiosIns.put(`admin/targeting/${targeting.id}`, targeting).then(response => response.data)
  },
}
export default TargetingService
